// HubSpot source tracking for the booking. The backend submits new customers
// to a HubSpot form with these values, so the contact's Original Source
// reflects the website visit (e.g. Paid search) instead of "Offline sources".

const LANDING_KEY = "t2d_landing_url";

// Call on app start: the first URL of the visit, query string included
export function captureLandingUrl(href) {
  try {
    if (!sessionStorage.getItem(LANDING_KEY)) {
      sessionStorage.setItem(LANDING_KEY, href);
    }
  } catch (e) {
    // Storage blocked: the current URL is used instead
  }
}

// The current page URL, or the landing URL when navigating through the
// steps has dropped the query string (UTMs, gclid) it arrived with
function pageUri() {
  const current = window.location.href;
  if (window.location.search) return current;
  try {
    const landing = sessionStorage.getItem(LANDING_KEY);
    if (landing && landing.includes("?")) return landing;
  } catch (e) {
    // fall through
  }
  return current;
}

// The hubspotutk cookie is set by the HubSpot tracking code; it's missing
// when the visitor declined cookies, and is then left out
function hubspotutk() {
  const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export function getHubspotTracking() {
  const hutk = hubspotutk();
  return {
    ...(hutk && { hubspotutk: hutk }),
    page_uri: pageUri(),
    page_name: document.title,
  };
}
